import { createSlice } from '@reduxjs/toolkit';
// Slice dla aktywnej zakładki w użytkownikach
const promoSlice = createSlice({
  name: 'promo', // Nazwa slice'a
  initialState: {
    checkedItems: [], // Lista zaznaczonych checkboxów
    activeTab: 'promo', // Domyślna aktywna zakładka
    currentPage: 1, // Domyślna strona
    maxPages: 1, // Domyślna maksymalna liczba stron
    totalCount: 0,
    // role: "USER",
    sortBy: null,
    sortDirection: null, // Domyślny kierunek sortowania
    //
    keyword: null, // Wyszukiwana fraza
    searchValue: '', // Wartość wyszukiwania
    filters: {
      dateFrom: '',
      dateTo: '',
      organizerId: '',
      promotionType: '',
      status: '',
    },
    //
    // addModalOpen: false, // Stan modala dodawania
    // editModalOpen: false, // Stan modala edycji
    // editedUser: null, // Dane edytowanego sportu
    // needRefresh: 1, // Flaga do wymuszenia odświeżenia
    //
    // modalViewActualTab: "Dane podstawowe",

  },
  reducers: {

      toggleActiveTab: (state, action) => {
          state.activeTab = action.payload;
      },

    // setViewedUser(state, action) {
    //     state.viewedUser = action.payload;
    // },
    setCheckedItems: (state, action) => {
      state.checkedItems = action.payload; // Ustawienie nowej listy zaznaczonych elementów
    },
    toggleCheckedItem: (state, action) => {
      const id = action.payload;
      if (state.checkedItems.includes(id)) {
        // Usuń id, jeśli już istnieje
        state.checkedItems = state.checkedItems.filter((item) => item !== id);
      } else {
        // Dodaj id, jeśli nie istnieje
        state.checkedItems.push(id);
      }
    },
    setSorting(state, action) {
          state.checkedItems = [];
          const { sortBy, sortDirection } = action.payload;
          state.sortBy = sortBy;
          state.sortDirection = sortDirection;
          state.currentPage = 1;
        },
    setPage(state, action) {
          state.currentPage = action.payload;
        },
    setMaxPages(state, action) {
          state.maxPages = action.payload;
        },
    setTotalCount(state, action) {
          state.totalCount = action.payload;
        },
    // toggleNeedRefresh: (state) => {
    //       state.needRefresh = state.needRefresh === 1 ? 0 : 1; // Przełączanie flagi odświeżenia
    //     },
    // toggleAddModal(state) {
    //       state.addModalOpen = !state.addModalOpen; // Przełączanie stanu modala dodawania
    //     },
    // toggleEditModal(state) {
    //       state.editModalOpen = !state.editModalOpen;
    //       // state.editedSport = action.payload || null; // Ustaw dane edytowanego sportu lub resetuj
    //     },
    setKeyword: (state, action) => {
          state.keyword = action.payload; // Ustawienie wyszukiwanej frazy
          state.currentPage = 1;
        },
    setSearchValue: (state, action) => {
          state.searchValue = action.payload; // Ustawienie wartości wyszukiwania
        },
    setFilters: (state, action) => {
          state.filters = action.payload;
          state.currentPage = 1;
          state.checkedItems = [];
        },
    clearFilters: (state) => {
          state.filters = {
            dateFrom: '',
            dateTo: '',
            organizerId: '',
            promotionType: '',
            status: '',
          };
          state.currentPage = 1;
          state.checkedItems = [];
        },
    // setModalViewActualTab(state, action) {
    //   state.modalViewActualTab = action.payload; // Zmieniona nazwa
    //   },
    }
});

export const {
  // setViewedUser,
  setCheckedItems,
  toggleCheckedItem,
  // setActiveUsersTab,
  setPage,
  setMaxPages,
  setTotalCount,
  setSorting,
  // toggleAddModal,
  // toggleEditModal,
  // toggleNeedRefresh,
  setKeyword,
  setSearchValue,
  // setModalViewActualTab
    toggleActiveTab,
  setFilters,
  clearFilters,
} = promoSlice.actions; // Eksport akcji
export default promoSlice.reducer;
